module.exports = __webpack_public_path__ + "static/media/delete-bin-2-line.8032d4a4.svg";